import { Plus } from "lucide-react";

import { CardsStudiedChart } from "@/components/CardsStudiedChart";
import { DeckReviewMessage } from "@/components/DeckReviewMessage";
import { Button } from "@/components/ui/button";
import { useAllDecks } from "@/hooks/useAllDecks";
import { LazySpinner } from "@/components/Spinner";

export const AllDecks = () => {
  const decks = useAllDecks();

  // For the charts, we're using placeholder content as specified
  const totalCards = decks?.reduce((acc, deck) => acc + deck.cardCount, 0) ?? 0;
  const totalDecks = decks?.length ?? 0;
  const toReviewCount =
    decks?.reduce((acc, deck) => (!deck.isMuted ? acc + deck.toReviewCount : acc), 0) ?? 0;

  return (
    <>
      <h1 className="text-2xl font-bold mb-4 py-1">All Decks</h1>
      <p className="text-gray-600 mb-6">
        {totalCards} card{totalCards !== 1 ? "s" : ""} in {totalDecks} deck
        {totalDecks !== 1 ? "s" : ""}
      </p>
      {!decks ? (
        // Loading state
        <div className="flex-1 flex items-center justify-center h-full">
          <LazySpinner />
        </div>
      ) : decks.length === 0 ? (
        // After loading, if no decks are found
        <div className="bg-gray-50 rounded-lg p-8 mb-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
              <span className="text-gray-600">i</span>
            </div>
            <h2 className="font-bold text-lg">Welcome!</h2>
          </div>
          <p className="text-gray-600 ml-9">
            You haven't created any decks yet. Use the{" "}
            <Button size="icon-sm" variant="muted" className="cursor-default">
              <Plus />
              <span className="sr-only">Add Deck</span>
            </Button>{" "}
            or{" "}
            <Button size="icon-md" className="cursor-default">
              <Plus />
              <span className="sr-only">Add new</span>
            </Button>{" "}
            buttons to create your first deck.
          </p>
        </div>
      ) : (
        <>
          {toReviewCount > 0 && <DeckReviewMessage toReviewCount={toReviewCount} />}
          <div className="mb-8">
            <h2 className="font-bold text-lg mb-4">Progress</h2>
            <h3 className="text-gray-600 font-medium mb-2">Cards Studied</h3>
            <CardsStudiedChart />
          </div>
        </>
      )}
    </>
  );
};
